import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NOTIFY } from "../../based/Constants";
import PropTypes from "prop-types";
import Textbox from "../../based/inputs/Textbox";
import CommonModal from "../../based/Modal";
import { Notify } from "../../based/Notify";
import TemplateTypeServices from "../../based/services/TemplateTypeServices";
import useFormValidate from "../../hooks/useFormValidate";
import Common from "../../based/Common";



const TemplateTypeModel = {
    id:0,
    name:""
}
const AddOrEditModal = (props) => {
    const [isBusy, setIsBusy] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [msg, setMsg] = useState(null);
    const [templateType, setTemplateType] = useState(TemplateTypeModel);
    const { addRef, displayError, isValid } = useFormValidate();
    const [check, setCheck] = useState(true);

    useEffect(() => {
        if (props.id > 0) getTemplateType(props.id);
        else setTemplateType({ ...TemplateTypeModel });
        return () => setTemplateType({ ...TemplateTypeModel });
    }, [props.id]);

    const getTemplateType = async (id) => {
        setIsBusy(true);
        let [err, data] = await TemplateTypeServices.GetTemplateTypeById(id);
        if (!err && data) {
            setIsBusy(false);
            setTemplateType({ ...data });
        } else {
            setIsBusy(false);
            setTemplateType(TemplateTypeModel);
        }
    };
    const _handleSave = async () => {
        if (isValid()) {
            setIsBusy(true);
            let [err, data] = await TemplateTypeServices.CreateUpdateTemplateType({ ...templateType });
            if (!err && data == 1) {
                setIsBusy(false);
                setTemplateType(TemplateTypeModel);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            } else {
                if (data == -2) {
                    setIsBusy(false);
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Kiểu tempalte đã tồn tại");
                } else {
                    setIsBusy(false);
                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
                }
            }
            props.onSaveContinue();
        }
    };
    return (
        <CommonModal show={props.isShowModal} id={Common.generateGuid()} isBusy={isBusy} busyMsg={msg} title={props.id > 0 ? "Cập nhật" : "Thêm mới"} onSave={_handleSave} onClose={() => props.onClose()}>
            <div className='form-group'>
                <label htmlFor='name' className='required'>
                    Tên hiển thị:
                </label>
                <Textbox id='name' name='name' required ref={addRef} className='form-control' onChanged={(name, value) => setTemplateType({ ...templateType, name: value })} value={templateType.name} />
            </div>
        </CommonModal>
    );
};

export default AddOrEditModal;

AddOrEditModal.propTypes = {
    isShowModal: PropTypes.bool,
    onClose: PropTypes.func,
    id: PropTypes.number,
    onSaveContinue: PropTypes.func,
};
